import React from 'react';
import { motion } from 'framer-motion';
import { DollarSign, Copy, Frown, Clock, RefreshCcw } from 'lucide-react';
export function ProblemAgitation() {
  const problems = [{
    icon: <DollarSign className="w-8 h-8 text-red-500" data-id="element-288" />,
    title: 'Sobres a precio inflado',
    desc: 'Gastás de más desde el primer día'
  }, {
    icon: <Copy className="w-8 h-8 text-red-500" data-id="element-289" />,
    title: 'Figuritas repetidas',
    desc: 'Comprás 10 para conseguir 1'
  }, {
    icon: <Frown className="w-8 h-8 text-red-500" data-id="element-290" />,
    title: "Las 'difíciles' nunca aparecen",
    desc: 'Frustrante para vos y para tus hijos'
  }, {
    icon: <Clock className="w-8 h-8 text-red-500" data-id="element-291" />,
    title: 'El tiempo de buscarlas',
    desc: 'Semanas o meses sin completarlo'
  }, {
    icon: <RefreshCcw className="w-8 h-8 text-red-500" data-id="element-292" />,
    title: 'Revenderlas o cambiarlas',
    desc: 'Complicado y poco confiable'
  }];
  return <section className="py-20 bg-gray-50" data-id="element-293">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-294">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-295">
          <h2 className="text-4xl md:text-5xl text-wc-dark mb-6 font-[800]" data-id="element-296">
            Seamos honestos. 😤
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto font-[700]" data-id="element-297">
            Completar un álbum del Mundial físico en 2026 es casi imposible sin
            gastar una cantidad ridícula de plata.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-298">
          {problems.map((prob, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col items-center text-center" data-id="element-299">
              <div className="bg-red-50 p-4 rounded-full mb-4" data-id="element-300">{prob.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-301">
                {prob.title}
              </h3>
              <p className="text-gray-600" data-id="element-302">{prob.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-wc-dark text-white p-8 rounded-2xl text-center max-w-3xl mx-auto shadow-xl" data-id="element-303">
          <p className="text-2xl font-bold mb-4 text-wc-yellow" data-id="element-304">
            Y lo peor de todo...
          </p>
          <p className="text-3xl font-display mb-4" data-id="element-305">El Mundial dura poco.</p>
          <p className="text-xl text-gray-300" data-id="element-306">
            Cuando querés completar el álbum, ya pasó la fiebre y la emoción se
            fue.
          </p>
        </motion.div>
      </div>
    </section>;
}